import { EmoticonNeutralIcon } from './EmoticonNeutralIcon';

/**
 * author: Michael Irigoyen
 * id 922B06B7-9C78-452C-AF29-79A47F0F6931
 * name emoticon-neutral
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-neutral.svg
 * tags
 * - Emoji 
 */
export const EmojiNeutralIcon = EmoticonNeutralIcon;
export default EmojiNeutralIcon